import { FullStory as FullStoryClient, isInitialized } from '@fullstory/browser';
import { IAnalyticsEventProperties, AnalyticsEventTypes } from 'lib/client/services/mixpanel/useAnalytics';
import logger from '@finance/shared/dist/utils/logger';
import { useCallback } from 'react';

export default function useFullStory() {
    const trackFullstoryEvent = useCallback(
        ({ event, type, props = {} }: { event: string; type: AnalyticsEventTypes; props?: IAnalyticsEventProperties }) => {
            try {
                if (!isInitialized()) {
                    logger.debug({ event, type, props }, '[tracking: fullStory] - FullStory not initialized, skipping event');
                    return;
                }

                const name = type || 'action';
                const description = event;
                const properties = { ...props, description };
                logger.debug({ name, description, props }, '[tracking: fullStory]');
                FullStoryClient('trackEvent', {
                    name,
                    properties
                });
            } catch (error) {
                logger.error({ error, event, type, props }, '[tracking: fullStory] - Failed to track event');
            }
        },
        []
    );

    return {
        trackFullstoryEvent
    };
}
